import config from "../../../helper/config";
import APIHandler from "../../../handlers/APIHandler";

export const purchaseMethodService = {
    getAll,
    getAllPurchaseMethods,
    addPurchaseMethod,
    updatePurchaseMethod,
    deletePurchaseMethod,
};

async function getAll(limit, offset, search_term, sort_column, sort_direction) {
    const configOptions = {
        method: "GET",
        headers: APIHandler.getHeader(config.azure_ad_config.apis.OAT.name),
    };
    
    const response = await fetch(
        `${config.oat_api_url}/manage/assessment-subscription/purchase-methods/getAllPurchaseMethods/?limit=${limit}&offset=${offset}&search_term=${search_term}&sort_column=${sort_column}&sort_direction=${sort_direction}`,
        configOptions
    );
    return APIHandler.handleResponse(response);
}

async function getAllPurchaseMethods() {
    const configOptions = {
        method: "GET",
        headers: APIHandler.getHeader(config.azure_ad_config.apis.OAT.name),
    };

    const response = await fetch(
        `${config.oat_api_url}/manage/assessment-subscription/purchase-methods/getAll/`,
        configOptions
    );
    return APIHandler.handleResponse(response);
}

async function addPurchaseMethod(newPurchaseMethod) {
    const configOptions = {
        method: "POST",
        headers: APIHandler.getHeader(config.azure_ad_config.apis.OAT.name),
        body: JSON.stringify(newPurchaseMethod),
    };

    const response = await fetch(
        `${config.oat_api_url}/manage/assessment-subscription/purchase-methods/add/`,
        configOptions
    );
    return APIHandler.handleResponse(response);
}

async function updatePurchaseMethod(purchaseMethodItem, purchaseMethodId) {
    const configOptions = {
        method: "PUT",
        headers: APIHandler.getHeader(config.azure_ad_config.apis.OAT.name),
        body: JSON.stringify(purchaseMethodItem),
    };

    const response = await fetch(
        `${config.oat_api_url}/manage/assessment-subscription/purchase-methods/update/${purchaseMethodId}`,
        configOptions
    );
    return APIHandler.handleResponse(response);
}

async function deletePurchaseMethod(id) {
    const configOptions = {
        method: "DELETE",
        headers: {
        ...APIHandler.getHeader(config.azure_ad_config.apis.OAT.name),
        "Content-Type": "application/json",
        },
    };

    const response = await fetch(
        `${config.oat_api_url}/manage/assessment-subscription/purchase-methods/delete/${id}`,
        configOptions
    );
    return APIHandler.handleResponse(response);
}
